var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgXTakedepositicon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "46px",
    viewBox: "0 0 20 46",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Take deposit icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Take-deposit-icon",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Deposit",
    transform: "translate(4.000000, 16.000000)",
    fill: "#933CC1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.4607978,9.373 C3.4607978,10.409 2.53273728,11.3015 1.26313618,11.90875 L2.23232462,13.8775 C3.03878955,13.43125 3.86313618,13.1075 4.56767538,13.1075 C5.79793673,13.1075 6.46492435,14 8.2173315,14 C9.68899587,14 10.6385144,13.55375 11.2,12.98325 L10.0537827,10.6925 C9.78913343,11.05825 9.18473177,11.42225 8.31925722,11.42225 C7.3303989,11.42225 6.86547455,10.752 5.69779917,10.752 C5.39559835,10.752 5.01292985,10.81325 4.71072902,10.91475 C5.4349381,10.4685 6.02145805,9.618 6.02145805,8.66425 C6.02145805,8.54 6.00178817,8.39825 6.00178817,8.2775 L8.25845942,8.2775 L8.25845942,6.63425 L5.3562586,6.63425 C4.89312242,5.9045 4.36918845,5.2745 4.36918845,4.24025 C4.36918845,3.10275 5.29367263,2.352 6.48459422,2.352 C7.41265475,2.352 8.2173315,2.94175 8.54099037,3.794 L10.8191197,2.4535 C9.97152682,0.791 8.37826685,0 6.14126547,0 C3.76299862,0 1.2434663,1.62225 1.2434663,4.19825 C1.2434663,5.19225 1.66726272,5.94475 2.16973865,6.63425 L0.8,6.63425 L0.8,8.2775 L3.2176066,8.2775 C3.35887208,8.62225 3.4607978,8.988 3.4607978,9.373",
    id: "Fill-37"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXTakedepositicon);
export default __webpack_public_path__ + "static/media/xTakedepositicon.76b1727c449a97a211402dafec806468.svg";
export { ForwardRef as ReactComponent };